import React, { useEffect, useState } from 'react';
import { Button,Container, IconButton, Grid, FormGroup, TextField, Typography, FormHelperText,FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from './api.js'; // api.js をインポート
import PdfModalViewer from './PdfModalViewer.js';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import { useNavigationHistory } from './common/navigationHistory.js';
import BackButton from './common/BackButton.js';
import HamburgerMenu from './components/Hamburger.jsx';
import Header from "./components/Header.jsx";

const SDGS_GOAL_OPTIONS = [
  { value: "1", label: "1. 貧困をなくそう" },
  { value: "2", label: "2. 飢餓をゼロに" },
  { value: "3", label: "3. すべての人に健康と福祉を" },
  { value: "4", label: "4. 質の高い教育をみんなに" },
  { value: "5", label: "5. ジェンダー平等を実現しよう" },
  { value: "6", label: "6. 安全な水とトイレを世界中に" },
  { value: "7", label: "7. エネルギーをみんなに そしてクリーンに" },
  { value: "8", label: "8. 働きがいも経済成長も" },
  { value: "9", label: "9. 産業と技術革新の基盤をつくろう" },
  { value: "10", label: "10. 人や国の不平等をなくそう" },
  { value: "11", label: "11. 住み続けられるまちづくりを" },
  { value: "12", label: "12. つくる責任 つかう責任" },
  { value: "13", label: "13. 気候変動に具体的な対策を" },
  { value: "14", label: "14. 海の豊かさを守ろう" },
  { value: "15", label: "15. 陸の豊かさも守ろう" },
  { value: "16", label: "16. 平和と公正をすべての人に" },
  { value: "17", label: "17. パートナーシップで目標を達成しよう" },
];

const Comp19Sub = ({
  changeModalOpen,
  exhibitorId: propExhibitorId,
  isModal=false,
  isCorpModal=false,
  setFormModalOpen,
  selectedFormKey,
  setExhibitors
}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null); 
  const [mypageData, setMypageData] = useState(null);
  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_19_name: mypageData.user_name || "",
        user_19_department: mypageData.department || "",
        user_19_phone: mypageData.phone_number || "",
        user_19_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_19_name: "",
        user_19_department: "",
        user_19_phone: "",
        user_19_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  const [formData, setFormData] = useState({
    user_19_name: "",
    user_19_department: "",
    user_19_phone: "",
    user_19_tel: "",
    com_name: "",
    exhibit_ways: "",
    sdgs_goals: [],
    basic_structure: false,
    basic_chair: false,
    side_panel: false,
    additional_certs: 0,
    alfa_text: "",
  });
  const [corrections, setCorrections] = useState({
    user_19_info: false,
    exhibit_ways: false,
    sdgs_goals: false,
  });
  const field_name_map = {
    user_19_info: "担当者情報",
    exhibit_ways: "出展内容",
    sdgs_goals: "推進するSDGsゴール",
  };
  const [open, setOpen] = useState(false);
  const [memoText, setMemoText] = useState('');
  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections((prev) => ({
      ...prev,
      [fieldKey]: e.target.checked,
    }));
  };
  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };
  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };
  const handleCorrection = async () => {
      try {
        // 選択された修正項目を日本語に変換して抽出
        const selectedFields = Object.entries(corrections).flatMap(([_, items]) =>
          Object.entries(items[0])
            .filter(([_, checked]) => checked)
            .map(([field]) => field_name_map[field] || field)
        );

        if (selectedFields.length === 0) {
          alert('修正対象の項目を選択してください');
          return;
        }

        const currentPath = window.location.pathname;

        await api.patch('/api/host-correction', {
          exhibitor_id: exhibitorId,
          form_type: selectedFormKey,
          correction: selectedFields,
          memo: memoText,
          current_path: currentPath,
        });

        // 👇 これ追加
        updateStatus(exhibitorId, 'r19', {
          host: '未確認',
          corporate: '未確認',
        });

        alert('修正リクエスト送信完了');
        setFormModalOpen(false);

        // UIリセット
        setCorrections({
          r19: [Object.fromEntries(Object.keys(corrections.r1[0]).map(k => [k, false]))]
        });
        setMemoText('');

      } catch (err) {
        console.error(err);
        alert('修正処理でエラーが発生しました');
      }
    };

    const updateHostStatus = (exhibitorId, formType, newStatus) => {
      setExhibitors((prev) =>
        prev.map((ex) =>
          ex.exhibitor_id === exhibitorId
            ? {
                ...ex,
                [`${formType}_host_status`]: newStatus,
                [`${formType}_corporate_status`]: newStatus, // ←これ追加
              }
            : ex
        )
      );
    };
  const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });

      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };
  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);
  const [isHovered, setIsHovered] = useState(false);
  const pdfItems = [
    // { label: 'INDEX', path: '/INDEX.pdf' },
    { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
  ];
  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );
  useEffect(() => {
  const fetchR19InitialData = async () => {
      try {
      const user = JSON.parse(localStorage.getItem("user"));

      const [resStatus, resR19, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/r19submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
      ]);

      const r19Status = resStatus.data?.r19_status || "";
      const r19Data = resR19.data || {};
      const mypage = resMypage.data || {};

      if (Object.values(r19Data).some(v => {
      if (Array.isArray(v)) return v.length > 0;
      return v !== "" && v !== null && v !== undefined;
      })) {
      setFormData(prev => ({
          ...prev,
          ...r19Data,
      }));
      if (
        r19Data.user_19_name === mypage.user_name &&
        r19Data.user_19_department === mypage.department &&
        r19Data.user_19_phone === mypage.phone_number &&
        r19Data.user_19_tel === mypage.tel_number
      ) {
        setSameAsExhibitor("same");
        setFieldsDisabled(true);
      } else {
        setFieldsDisabled(false);
      }
      }

      } catch (err) {
      console.error("R19初期データ取得エラー:", err);
      }
    };

  fetchR19InitialData();
  }, []);
  const [submitErrors, setSubmitErrors] = useState({});
  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const submitErrors = {};
      const exhibit_ways = (formData?.exhibit_ways || "").trim();

      if (!exhibit_ways) {
        submitErrors.exhibit_ways = "入力してください";
      } else if (exhibit_ways.length > 100) {
        submitErrors.exhibit_ways = "100文字以内で入力してください";
      }
      const allErrors = submitErrors;

      if (Object.keys(allErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          user_19_name: "担当者名",
          user_19_department: "担当部署",
          user_19_phone: "担当者携帯",
          user_19_tel: "担当者電話",
          exhibit_ways: "出展内容",
          additional_certs: '追加出展者証',
        };

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: {
          ...formData,
          sdgs_goals: Array.isArray(formData.sdgs_goals)
            ? formData.sdgs_goals.map((goal) => String(goal))
            : [],
        },
      };

      const res = await api.post("/api/submit-r19", payload);
      
      if (res.status === 200) {
        alert("保存成功");
      } else {
        alert("保存失敗");
      }

      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          if (user?.user_id === 0) {
            navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
          } else {
            navigate(`/mypage/${user?.mypage_id}`);
          }
        }
      }, 1000);
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };
  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };
  const handleCatchRadio = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value === "true" });
  };
  const handleSdgsGoalChange = (goalValue) => (event) => {
    setFormData((prev) => {
      const currentGoals = Array.isArray(prev.sdgs_goals)
        ? prev.sdgs_goals.map((goal) => String(goal))
        : [];

      return {
        ...prev,
        sdgs_goals: event.target.checked
          ? [...currentGoals, goalValue]
          : currentGoals.filter((goal) => goal !== goalValue),
      };
    });
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
    useConfirmBackLogout(navigate);
    useNavigationHistory();
  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS

  return (
    <>
    <div sx={{mx: 0, px: 0 , width: '100%'}}>
    {!isCorpModal &&(
      <Header
        title="SDGs 子ども・ユースフェア2026 展示内容確認届"
        companyName={mypageData?.company_name}
      />
    )}
    <style>
    {`
    @media only screen and (max-width: 560px) {
    .sm-block {display: block;}
    .sm-none {display: none;}
    .sm-column {flex-direction: column;}
    .noti-cate {font-size: 19px;}
    .timestamp {font-size: 14px;}
    .info {font-size: 14px;}
    .f-16 {font-size: 16px;}
    }
    @media only screen and (min-width: 561px) {
    .hamburger_menu_btn_wrap {display: none;}
    }
    `}
    </style>
    <Container sx={{ display: 'flex' }}>
      {!isCorpModal &&(
      <>
      <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box
              className={`menu-item`}
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`${user?.mypage_url}`);
              }}
            >
              TOP
            </Box>
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user'));
                navigate(`/mypage-info/${user?.exhibitor_id}`);
              }}
            >
              出展者情報編集
            </Box>
            <Box 
              className="menu-item"
              onClick={() => {
                navigate('/mail-form/');
              }}
            >
              お問い合わせ
            </Box>
            {renderMenuItems()}
            <Box 
              className="menu-item"
              onClick={() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const mypage = user?.mypage_url;

                handleScrollTo('news', mypage);
              }}
            >
              お知らせ
            </Box>
            <Box
              className="menu-item"
              onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
            >
              個人情報保護方針
            </Box>
          </Box>
        </Box>
        <BackButton />
      </Container>
      <HamburgerMenu />
      </>
      )}
      {!!changeModalOpen &&(
        <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
          <Typography variant="h6" gutterBottom>
            修正内容のメモ
          </Typography>
          <TextField
            multiline
            rows={20}
            fullWidth
            placeholder="ここに修正内容を書いてください..."
            value={memoText}
            onChange={(e) => setMemoText(e.target.value)}
          />
          <Box>
            <Typography variant="h6">マイページ情報</Typography>
            {mypageData ? (
              <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                <Typography variant="body1">部署: {mypageData.department}</Typography>
                <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                <Typography variant="body1">住所: {mypageData.address}</Typography>
                <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
              </Box>
            ) : (
              <Typography variant="body2">読み込み中...</Typography>
            )}
          </Box>
        </Box>
      )}
      <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>

          <Typography variant="h6" gutterBottom className="f-19">
            展示内容確認届
          </Typography>

          <Grid sx={{ p: { xs: 0, md: 2 } }}>
            {!!changeModalOpen &&(
              <FormControlLabel
                control={
                  <Checkbox
                    checked={corrections.user_19_info}
                    onChange={handleCorrectionChange("user_19_info")}
                    sx={{
                color: 'red', // 未チェック時の枠の色
                '&.Mui-checked': {
                  color: 'red', // チェック時の色
                },
              }}
                  />
                }
                label="担当者情報"
              />
            )}
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Grid container spacing={2}>
            <Grid size={6}><TextField fullWidth label="氏名" name="user_19_name" value={formData?.user_19_name} disabled={fieldsDisabled} onChange={handleChange("user_19_name")} error={!!submitErrors.user_19_name} helperText={submitErrors.user_19_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="部署" name="user_19_department" value={formData?.user_19_department} disabled={fieldsDisabled} onChange={handleChange("user_19_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_19_phone" value={formData?.user_19_phone} disabled={fieldsDisabled} onChange={handleChange("user_19_phone")} error={!!submitErrors.user_19_phone} helperText={submitErrors.user_19_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_19_tel" value={formData?.user_19_tel} disabled={fieldsDisabled} onChange={handleChange("user_19_tel")} error={!!submitErrors.user_19_tel} helperText={submitErrors.user_19_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
            </Grid>
            <Typography color="error">※ご連絡可能な電話番号をご入力ください。</Typography>
            <Typography variant='h6'>HP等へ反映のための最終確認になります。<br />出展申込と変更がない場合でも必ず記入の上、提出してください。</Typography>

            <TextField
                label="出展名（企業・団体名の最終確認になります。こちらの記載の名称にて、HP等の広報物に反映します。）"
                name="com_name"
                value={formData?.com_name}
                onChange={handleChange("com_name")}
                sx={{ mb: 1 }}
                fullWidth
            />
            <Typography color='error' sx={{mb:5}}>※企業・団体名の最終確認になります。こちらの記載の名称にて、HP等の広報物に反映します。</Typography>
            {!!changeModalOpen && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={corrections.exhibit_ways}
                    onChange={handleCorrectionChange("exhibit_ways")}
                    sx={{ color: "red", "&.Mui-checked": { color: "red" } }}
                  />
                }
                label="出展内容"
              />
            )}
            <TextField
                label="出展内容"
                name="exhibit_ways"
                value={formData?.exhibit_ways}
                onChange={handleChange("exhibit_ways")}
                error={
                formData?.exhibit_ways &&
                formData?.exhibit_ways.length > 100
                }
                helperText={
                formData?.exhibit_ways &&
                formData?.exhibit_ways.length > 100
                    ? "100文字以内で入力してください"
                    : ""
                }
                sx={{ mb: 1 }}
                fullWidth
            /> 
            <Typography color='error' sx={{mb:5}}>※出展内容は100文字までとなります。</Typography>       
            <Box>
                {!!changeModalOpen && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.sdgs_goals}
                        onChange={handleCorrectionChange("sdgs_goals")}
                        sx={{ color: "red", "&.Mui-checked": { color: "red" } }}
                      />
                    }
                    label="推進するSDGsゴール"
                  />
                )}
                <Typography variant='h6'>推進するSDGsゴール</Typography>
                <Typography color='error'>※下記より該当のものを選択ください。複数選択可。</Typography>
                <FormGroup sx={{ mt: 1 }}>
                  {SDGS_GOAL_OPTIONS.map((goal) => (
                    <FormControlLabel
                      key={goal.value}
                      control={
                        <Checkbox
                          checked={(formData.sdgs_goals || []).map((value) => String(value)).includes(goal.value)}
                          onChange={handleSdgsGoalChange(goal.value)}
                        />
                      }
                      label={goal.label}
                    />
                  ))}
                </FormGroup>
            </Box>
            <Typography variant='h6'>基礎小間付帯設備　利用確認</Typography>
            <Box sx={{ display: 'flex', mt: 2 }} className="sp-column">
              {mypageData?.booth_form !== "シマ" && (
              <>
              <FormControl>
                <FormLabel>長机</FormLabel>
                <RadioGroup
                  row
                  name="basic_structure"
                  value={formData?.basic_structure?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>

              <FormControl>
                <FormLabel>パイプ椅子</FormLabel>
                <RadioGroup
                  row
                  name="basic_chair"
                  value={formData?.basic_chair?.toString() ?? ""}
                  onChange={handleCatchRadio}
                >
                  <FormControlLabel value="true" control={<Radio />} label="使用する" />
                  <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                </RadioGroup>
              </FormControl>
              </>
              )}

              {mypageData?.booth_corner && (
                <FormControl>
                  <FormLabel>側面パネル</FormLabel>
                  <RadioGroup
                    row
                    name="side_panel"
                    value={formData?.side_panel?.toString() ?? ""}
                    onChange={handleCatchRadio}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="使用する" />
                    <FormControlLabel value="false" control={<Radio />} label="使用しない" />
                  </RadioGroup>
                </FormControl>
              )}
            </Box>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <TextField fullWidth multiline minRows={4} label="備考" value={formData?.alfa_text || ""} onChange={handleChange("alfa_text")} />
          </Box>
        </Box>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography className='info'>
            【上記入力内容についてのお問い合わせ先】<br/>
            SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社 事業部内）<br/>
            担当：佐野、三宅<br/>
            TEL:052-561-5675<br/>
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br/>
            ※お急ぎの場合はお電話にてお問い合わせください
          </Typography>
        </Box>
      </Container>
    </Container>
    {!isCorpModal &&(
    <>
    <Container sx={{textAlign: 'center'}}>
        <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
            提出する
        </Button>
    </Container>
    <footer>
      <Typography>
        © 2026 THE MID-JAPAN ECONOMIST.
      </Typography>
    </footer>
    </>
    )}
    {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
    </>
  );
};

export default Comp19Sub;
